var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartiviaSimbolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "310.138 -526.48 185.631 186.952",
    role: "img",
    "aria-label": "Cartivia",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cartiviaVerde",
    gradientUnits: "userSpaceOnUse",
    x1: 391.8,
    y1: 355.628,
    x2: 452.45,
    y2: 424.677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1c6d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#21795e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#278769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#2f9a79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#38b28c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#3ec298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#43d0a3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M395.665 465.873L416.036 488.349C416.036 488.349 367.544 502.884 336.519 469.904C336.519 469.904 302.606 442.105 316.926 387.215C316.926 387.215 316.876 380.163 325.83 369.348L310.138 339.528L468.076 494.934L350.98 398.585C350.98 398.585 333.888 389.761 338.01 425.426C338.01 425.426 342.183 468.144 395.665 465.873Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cartiviaVerde)",
    d: "M362.701 349.15C362.779 349.232 363.667 349.214 365.2 349.195L365.2 349.195C380.037 349.024 455.417 348.852 445.816 438.443Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2aad87",
    d: "M462.084 509.058L495.77 526.48L483.892 490.096L480.18 505.719Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartiviaSimbolo);
export default __webpack_public_path__ + "static/media/cartivia-simbolo.1ee8b842e3a024e5f494ce3064690d41.svg";
export { ForwardRef as ReactComponent };